import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core'; 
import * as Highcharts from 'highcharts';
import StockModule from 'highcharts/modules/stock';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);
StockModule(Highcharts);
@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.css']
})
export class ReportingComponent implements AfterViewInit {
  @ViewChild('chartContainer', { static: true }) chartContainer!: ElementRef;
  @ViewChild('chartContainerRevenew', { static: true }) chartContainerRevenew!: ElementRef;
  @ViewChild('comparismChartContainer', { static: true }) comparismChartContainer!: ElementRef;
  @ViewChild('comparismChartContainerMonthly', { static: true }) comparismChartContainerMonthly!: ElementRef;

  ngAfterViewInit(): void {
    this.createChartRevenew();
    this.createChart();
    this.createCompareChart();
    this.createCompareChartMonthly();
  }
  createChart(): void {
    const chartOptions: any = {
      chart: {
        type: 'pie',
        custom: {}, 
        events: {
         
        }
      },
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      title: {
        text: 'Today vendor wise activation'
      },
      subtitle: {
        text: 'All operator'
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.0f}</b>'
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          borderRadius: 8,
          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: '{point.name}'
            },
            {
              enabled: true,
              distance: -15,
              format: '{point.count:.0f}',
              style: {
                fontSize: '0.9em'
              }
            }
          ],
          showInLegend: true
        }
      },
      credits: {
        enabled: false 
      },
      series: [{
        name: 'Registrations',
        colorByPoint: true,
        innerSize: '75%',
        data: [
          { name: 'Traffic Company', y: 60.0, count: 1230 },
          { name: 'Admosteche', y: 15.0 , count: 230},
          { name: 'Harrimedia', y: 15.0, count: 212 },
          { name: 'Kimia', y: 10.0, count: 12 }
        ]
      }]
    };

    // Create the chart
    Highcharts.chart(this.chartContainer.nativeElement, chartOptions);
  }
  createChartRevenew() {
    var data = [
      [1, 20.1],
      [2, 20.9],
      [3, 20.3],
      [4, 21.2],
      [5, 22.1],
      [6, 22.4],
      [7, 22.9],
      [8, 23.5],
      [9, 24.1],
      [10, 24.6],
      [11, 25.2],
      [12, 26.0],
      [13, 26.4],
      [14, 27.1],
      [15, 27.5],
      [16, 28.0],
      [17, 28.6],
      [18, 29.1],
      [19, 29.7],
      [20, 30.2],
      [21, 30.6],
      [22, 31.1],
      [23, 31.5],
      [24, 32.0],
      [25, 32.4],
      [26, 33.0],
      [27, 33.5],
      [28, 34.1],
      [29, 34.6],
      [30, 35.0]
    ];    
    const options: Highcharts.Options = {
      title: {
        text: 'Revenew trend'
    },

    subtitle: {
        text: 'Grameenphone'
    },
      chart: {
        type: 'area',
        plotBorderWidth: 1,
        plotBorderColor: '#FFF',
        backgroundColor: '#FFF',
        margin: 0,
        width: null
      },
      stockTools: {
        gui: {
          enabled: false,
        },
      },
      credits: {
        enabled: false,
      },
      navigator: {
        enabled: false,
      },
      scrollbar: {
        enabled: false,
      },
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      xAxis: {
        type: 'datetime',
        lineWidth: 0,
        tickWidth: 0,
        labels: {
          enabled: false,
          style: {
            backgroundColor: 'none',
            border: 'none'
          }
        },
        gridLineWidth: 0
      },
      yAxis: {
        lineWidth: 0,
        tickWidth: 0,
        labels: {
          enabled: false,
          style: {
            backgroundColor: 'none',
            border: 'none'
          }
        },
        gridLineWidth: 0
      },
      rangeSelector: {
        buttons: [ {
          type: 'week',
          count: 1,
          text: '1W'
        }, {
          type: 'month',
          count: 1,
          text: '1M'
        },{
          type: 'year',
          count: 1,
          text: '1Y'
        }],
        selected: 0,
        inputEnabled: false,
        labelStyle: {
          display: "none"
        },
        buttonPosition: {
          align: 'right',
          x: 0,
          y: 0,
        },
        verticalAlign: 'bottom',
        floating: true,
        dropdown: "never",
        buttonTheme: {
          width: 16,
          height: 15,
          stroke: 'none',
          strokeWidth: 0,
          fill: 'none',
          style: {
            color: '#fff',
            fontSize: '10px'
          },
          states: {
            hover: {
              fill: 'none',
              style: {
                color: '#fff',
              },
            },
            select: {
              fill: 'none',
              style: {
                color: '#fff',
              },
            },
          },
        },
      },
      series: [{
        data: data,
        type: 'area',
        lineColor: '#2CB85C',
        lineWidth: 1,
        threshold: null,
        tooltip: {
          valueDecimals: 1,
        },
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, '#2CB85C'],
            [1, Highcharts.color('#2CB85C').setOpacity(0).get('rgba').toString()],
          ],
        },
      }],
    };

    // Create the chart
    Highcharts.stockChart(this.chartContainerRevenew.nativeElement, options);
  }

  createCompareChart(){
    const options: any = {
      title: {
          text: 'Sales comparism yearly',
          align: 'left'
      }, credits: {
        enabled: false,
      },
      xAxis: {
          categories: [
              'GP', 'BL', 'ROBI', 'BKash'
          ]
      },
      yAxis: {
          title: {
              text: 'TK'
          }
      },
      tooltip: {
          valueSuffix: ' TK'
      },
      plotOptions: {
          series: {
              borderRadius: '25%'
          }
      },
      series: [{
          type: 'column',
          name: '2022',
          data: [59, 83, 65, 228]
      }, {
          type: 'column',
          name: '2023',
          data: [24, 79, 72, 240]
      }, {
          type: 'column',
          name: '2024',
          data: [58, 88, 75, 250]
      }, {
          type: 'line',
          step: 'center',
          name: 'Average',
          data: [47, 83.33, 70.66, 239.33],
          marker: {
              lineWidth: 2,
              lineColor: Highcharts?.getOptions()?.colors?.at(3),
              fillColor: 'white'
          }
      }, {
          type: 'pie',
          name: 'Total',
          data: [{
              name: '2020',
              y: 619,
              color: Highcharts.getOptions().colors?.at(0), // 2020 color
              dataLabels: {
                  enabled: true,
                  distance: -50,
                  format: '{point.total} M',
                  style: {
                      fontSize: '15px'
                  }
              }
          }, {
              name: '2021',
              y: 586,
              color: Highcharts.getOptions().colors?.at(1) // 2021 color
          }, {
              name: '2022',
              y: 647,
              color: Highcharts.getOptions().colors?.at(2) // 2022 color
          }],
          center: [75, 65],
          size: 100,
          innerSize: '70%',
          showInLegend: false,
          dataLabels: {
              enabled: false
          }
      }]
    };
    Highcharts.chart(this.comparismChartContainer.nativeElement, options);
  }
  createCompareChartMonthly(){
    const options: any = {
      title: {
          text: 'Sales comparism monthly',
          align: 'left'
      }, credits: {
        enabled: false,
      },
      xAxis: {
          categories: [
              'GP', 'BL', 'ROBI', 'BKash'
          ]
      },
      yAxis: {
          title: {
              text: 'TK'
          }
      },
      tooltip: {
          valueSuffix: ' TK'
      },
      plotOptions: {
          series: {
              borderRadius: '25%'
          }
      },
      series: [{
          type: 'column',
          name: 'Jan',
          data: [59, 83, 65, 228]
      }, {
          type: 'column',
          name: 'Feb',
          data: [24, 79, 72, 240]
      }, {
          type: 'column',
          name: 'Mar',
          data: [58, 88, 75, 250]
      }, {
          type: 'line',
          step: 'center',
          name: 'Average',
          data: [47, 83.33, 70.66, 239.33],
          marker: {
              lineWidth: 2,
              lineColor: Highcharts?.getOptions()?.colors?.at(3),
              fillColor: 'white'
          }
      }, {
          type: 'pie',
          name: 'Total',
          data: [{
              name: 'Jan',
              y: 619,
              color: Highcharts.getOptions().colors?.at(0), // 2020 color
              dataLabels: {
                  enabled: true,
                  distance: -50,
                  format: '{point.total} M',
                  style: {
                      fontSize: '15px'
                  }
              }
          }, {
              name: 'Feb',
              y: 586,
              color: Highcharts.getOptions().colors?.at(1) // 2021 color
          }, {
              name: 'Mar',
              y: 647,
              color: Highcharts.getOptions().colors?.at(2) // 2022 color
          }],
          center: [75, 65],
          size: 100,
          innerSize: '70%',
          showInLegend: false,
          dataLabels: {
              enabled: false
          }
      }]
    };
    Highcharts.chart(this.comparismChartContainerMonthly.nativeElement, options);
  }
}
